import { RouteObject } from 'react-router-dom'
import About from '../../components/About/About'
import Cgu from '../../components/Cgu/Cgu'
import Contact from '../../components/Contact/Form/Contact'
import HelpCenterMain from '../../components/Help/HelpCenterMain'
import Legal from '../../components/Legal/Legal'
import PatientContainerHistory from '../../components/Patient/History/PatientContainerHistory'
import PatientList from '../../components/Patient/List/PatientList'
import PlannedConsultationMain from '../../components/PlannedConsultation/plannedConsultationMain/PlannedConsultationMain'
import PhysicianList from '../../components/RequiredExpert/List/PhysicianList'
import RequiredExpertCallout from '../../components/RequiredExpert/RequiredExpertCallout'
import Security from '../../components/User/Security'
import Main from '../../layouts/Main'
import RouterError from '../RouterError'
import RequestersList from '../../components/Requester/RequestersList'
import Requester from '../../components/Requester/Requester'
import RequesterCallout from '../../components/Requester/RequesterCallout'
import { LegacyHcsProvider } from '../../components/legacy/LegacyHcsProvider'
import { PlannedConsultationCreation } from '../../components/PlannedConsultation/PlannedConsultationEditor/PlannedConsultationCreation'
import { PlannedConsultationEdition } from '../../components/PlannedConsultation/PlannedConsultationEditor/PlannedConsultationEdition'
import TopBanner from '../../components/MainPage/TopBanner'
import { MyAccount } from '../../components/User/MyAccount'
import { PatientEdition } from '../../components/Patient/Form/PatientEdition'
import { PatientCreation } from '../../components/Patient/Form/PatientCreation'
import RequiredExpertEdition from '../../components/User/requiredExpert/RequiredExpertEdition'
import PlannedExpertiseMain from '../../components/Teleexpertise/plannedExpertiseMain/PlannedExpertiseMain'
import { PlannedExpertiseCreation } from '../../components/Teleexpertise/plannedExpertiseEditor/PlannedExpertiseCreation'
import PlannedExpertiseWorkflowTunnelPage from '../../components/Teleexpertise/plannedExpertiseWrorkflow/PlannedExpertiseWorkflowTunnelPage'

export const commonRoutes: RouteObject = {
    path: '/',
    children: [
        {
            path: '/',
            errorElement: <RouterError />,

            children: [
                {
                    path: '/',
                    element: (
                        <Main noBackground>
                            <TopBanner />
                            <PlannedConsultationMain isPreview />
                            <PlannedExpertiseMain isPreview />
                            <HelpCenterMain />
                        </Main>
                    ),
                },
                {
                    path: '/about',
                    element: (
                        <Main title="A propos" goBackTo="/">
                            <About />
                        </Main>
                    ),
                },
                {
                    path: '/cgu',
                    element: (
                        <Main title="Conditions générales d'utilisation" goBackTo="/">
                            <Cgu />
                        </Main>
                    ),
                },
                {
                    path: '/legal',
                    element: (
                        <Main title="Mentions légales" goBackTo="/">
                            <Legal />
                        </Main>
                    ),
                },
                {
                    path: '/network',
                    element: (
                        <Main title="Réseau de téléconsultants" goBackTo="/" callout={<RequiredExpertCallout />}>
                            <PhysicianList />
                        </Main>
                    ),
                },
                {
                    path: '/patients',
                    element: (
                        <Main title="Liste des patients" goBackTo="/">
                            <LegacyHcsProvider>
                                <PatientList key="main-PatientList" />
                            </LegacyHcsProvider>
                        </Main>
                    ),
                },
                {
                    path: '/planned-consultations',
                    element: (
                        <Main noBackground title="Téléconsultations planifiées" goBackTo="/">
                            <PlannedConsultationMain key="planned-consultations" />
                        </Main>
                    ),
                },
                {
                    path: '/me',
                    element: (
                        <Main title="Mon compte" goBackTo="/" noBackground>
                            <MyAccount />
                        </Main>
                    ),
                },
                {
                    path: '/security',
                    element: (
                        <Main title="Gestion sécurité" goBackTo="/">
                            <Security />
                        </Main>
                    ),
                },
                {
                    path: '/requesters',
                    element: (
                        <Main title="Liste des requérants de téléexpertise" goBackTo="/" callout={<RequesterCallout />}>
                            <RequestersList />
                        </Main>
                    ),
                },
                {
                    path: '/teleexpertises',
                    element: (
                        <Main noBackground title="Téléexpertises à finaliser" goBackTo="/">
                            <PlannedExpertiseMain />
                        </Main>
                    ),
                },
            ],
        },
        {
            path: '/teleexpertise',
            errorElement: <RouterError />,

            children: [
                {
                    index: true,
                    element: (
                        <Main noBackground tunnelMode>
                            <PlannedExpertiseCreation />
                        </Main>
                    ),
                },
                {
                    path: 'workflow/:transmissionId?',
                    element: <PlannedExpertiseWorkflowTunnelPage />,
                },
            ],
        },
        {
            path: '/contact',
            errorElement: <RouterError />,

            children: [
                {
                    path: '/contact/',
                    element: (
                        <Main title="Ajouter un correspondant" goBackTo="/contacts" noBackground>
                            <Contact mode="CREATION" />
                        </Main>
                    ),
                },
                {
                    path: '/contact/:id',
                    element: (
                        <Main title="Fiche du correspondant" goBackTo="/contacts" noBackground>
                            <Contact mode="EDITION" />
                        </Main>
                    ),
                },
            ],
        },
        {
            path: '/expert',
            errorElement: <RouterError />,

            children: [
                {
                    path: '/expert/:id',
                    element: (
                        <Main goBackTo="/network" title="Modifier un téléconsultant" noBackground>
                            <RequiredExpertEdition />
                        </Main>
                    ),
                },
            ],
        },
        {
            path: '/planned-consultation',
            errorElement: <RouterError />,

            children: [
                {
                    path: '/planned-consultation/',
                    element: (
                        <Main noBackground title="Nouvelle téléconsultation planifiée" goBackTo="/">
                            <PlannedConsultationCreation />
                        </Main>
                    ),
                },
                {
                    path: '/planned-consultation/:id',
                    element: (
                        <Main
                            noBackground
                            title="Modifier une téléconsultation planifiée"
                            goBackTo="/planned-consultations"
                        >
                            <PlannedConsultationEdition />
                        </Main>
                    ),
                },
            ],
        },
        {
            path: '/patient',
            errorElement: <RouterError />,

            children: [
                {
                    path: '/patient/',
                    element: (
                        <Main title="Ajouter un patient" goBackTo="/patients" noBackground>
                            <LegacyHcsProvider>
                                <PatientCreation isExternal={false} />
                            </LegacyHcsProvider>
                        </Main>
                    ),
                },
                {
                    path: '/patient/:id',
                    element: (
                        <Main title="Modifier un patient" goBackTo="/patients" noBackground>
                            <LegacyHcsProvider>
                                <PatientEdition isExternal={false} />
                            </LegacyHcsProvider>
                        </Main>
                    ),
                },
            ],
        },
        {
            path: '/:hcsId/patients',
            element: (
                <Main title="Liste des patients" goBackTo="/">
                    <LegacyHcsProvider>
                        <PatientList key="main-PatientList" />
                    </LegacyHcsProvider>
                </Main>
            ),
        },
        {
            path: '/patient-history/',
            errorElement: <RouterError />,

            children: [
                {
                    path: '/patient-history/:id',
                    element: (
                        <Main title="Historique patient" goBackTo="/patients">
                            <PatientContainerHistory />
                        </Main>
                    ),
                },
            ],
        },
        {
            path: '/requester',
            errorElement: <RouterError />,
            children: [
                {
                    path: '/requester/',
                    element: (
                        <Main title="Ajouter un requérant" goBackTo="/requesters" noBackground>
                            <Requester isExternal={false} mode="CREATION" />
                        </Main>
                    ),
                },
                {
                    path: '/requester/:id',
                    element: (
                        <Main title="Modifier un requérant" goBackTo="/requesters" noBackground>
                            <Requester isExternal={false} mode="EDITION" />
                        </Main>
                    ),
                },
            ],
        },
    ],
}
